import { FormEvent } from 'react'

import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import TextBlock from 'ui-component-library/components/00-Primitives/TextBlock'
import Link from 'content-components/_Primatives/Link'
import Loader from 'content-components/_Primatives/Loader'
import Button from '../Button'
import Label from '../Label'
import Checkbox from '../Checkbox'
import useFormFields from '../useFormFields'
import style from './style.scss'

type Props = {
  isFulfilling: boolean
  onSubmit: () => void
  titleText: string
  bodyText: string
  buttonText: string
  waiverLabelText: string
  waiverLink: string
  waiverLinkText: string
  ageConfirmationLabelText: string
  fullNameText: string
  yourBirthdayText: string
  user: { firstName?: string; lastName?: string; birthday?: string }
}

function Confirm({
  isFulfilling,
  onSubmit,
  titleText,
  bodyText,
  buttonText,
  waiverLabelText,
  waiverLink,
  waiverLinkText,
  ageConfirmationLabelText,
  user,
  fullNameText,
  yourBirthdayText,
}: Props) {
  const { ageConfirmation, waiverConfirmation, onChange } = useFormFields({
    ageConfirmation: false,
    waiverConfirmation: false,
  })

  function handleChangeCheckbox(event: FormEvent<HTMLInputElement>) {
    const { name, checked } = event.currentTarget

    if (name === 'ageConfirmation' || name === 'waiverConfirmation') {
      onChange({
        name,
        value: checked,
      })
    }
  }

  if (isFulfilling) {
    return <Loader />
  }

  return (
    <>
      <HeadlineTwo>{titleText}</HeadlineTwo>
      <TextBlock className={style.text}>{bodyText}</TextBlock>
      <div className={style.userDetails}>
        <div className={style.row}>
          <div className={style.label}>{fullNameText}</div>
          <div className={style.value}>
            {user.firstName} {user.lastName}
          </div>
        </div>
        {user.birthday && (
          <div className={style.row}>
            <div className={style.label}>{yourBirthdayText}</div>
            <div className={style.value}>{user.birthday}</div>
          </div>
        )}
      </div>

      <div className={style.checkboxGroup}>
        <Checkbox
          checked={waiverConfirmation}
          className={style.checkboxInput}
          id='waiverConfirmation'
          name='waiverConfirmation'
          onChange={handleChangeCheckbox}
        />
        <Label className={style.checkboxLabel} htmlFor='waiverConfirmation'>
          {waiverLabelText}{' '}
          <Link className={style.link} url={waiverLink}>
            {waiverLinkText}
          </Link>
        </Label>
      </div>
      <div className={style.checkboxGroup}>
        <Checkbox
          checked={ageConfirmation}
          className={style.checkboxInput}
          id='ageConfirmation'
          name='ageConfirmation'
          onChange={handleChangeCheckbox}
        />
        <Label className={style.checkboxLabel} htmlFor='ageConfirmation'>
          {ageConfirmationLabelText}
        </Label>
      </div>
      <Button
        className={style.button}
        disabled={!ageConfirmation || !waiverConfirmation}
        onClick={onSubmit}
      >
        {buttonText}
      </Button>
    </>
  )
}

export default Confirm
